'use client';

import classNames from 'classnames';

import { graphqlApi } from '~/shared/store/api-services/graphql-api';

import './students-attention-badge.scss';

type StudentsAttentionBadgeProps = Readonly<{
  className?: string;
}>;

const StudentsAttentionBadge = ({ className }: StudentsAttentionBadgeProps) => {
  const { data } = graphqlApi.useStudentsAttentionCountQuery();
  const count = data?.total ?? 0;

  if (count <= 0) {
    return null;
  }

  return (
    <span
      className={classNames('students-attention-badge', className)}
      aria-label={String(count)}
      title={String(count)}
    >
      {count}
    </span>
  );
};

export default StudentsAttentionBadge;
